import type { FC } from 'react'
import styles from './panel-empty-state.module.css'

export interface PanelEmptyStateProps {
  title: string
  body: string
}

/** A side panel with nothing to show: the dashed hint box of the left sidebar's empty Favorites */
export const PanelEmptyState: FC<PanelEmptyStateProps> = ({ title, body }) => (
  <div className={styles.empty}>
    <p className={styles.title}>{title}</p>
    <p className={styles.body}>{body}</p>
  </div>
)
